interface ToggleSwitchProps {
  checked: boolean
  onChange: (checked: boolean) => void
  label?: string
}

export default function ToggleSwitch({ checked, onChange, label }: ToggleSwitchProps) {
  return (
    <label className="inline-flex items-center gap-3 cursor-pointer select-none">
      <div className="relative">
        <input
          type="checkbox"
          className="sr-only peer"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          role="switch"
          aria-checked={checked}
        />
        <div
          className={`
            w-11 h-6 rounded-full transition-colors duration-200 ease-in-out
            peer-focus-visible:ring-2 peer-focus-visible:ring-accent peer-focus-visible:ring-offset-2 peer-focus-visible:ring-offset-bg
            ${checked ? 'bg-accent' : 'bg-raised border border-stroke-2'}
          `}
        />
        <div
          className={`
            absolute top-0.5 left-0.5 w-5 h-5 rounded-full transition-transform duration-200 ease-in-out
            ${checked ? 'translate-x-5 bg-[#1a1305]' : 'translate-x-0 bg-fg'}
          `}
        />
      </div>
      {label && (
        <span className="text-sm font-medium text-fg">
          {label}
        </span>
      )}
    </label>
  )
}
